import { IMapMngr } from '../interfaces';
import { AppConfig } from '../../app.config';

export class CreateTool extends NeWMI.Tool.CreateTool {

  private cursor = 'crosshair';
  private multiShape = false;

  constructor(protected mapMngr: IMapMngr) {
    super();
    this.id = CreateTool.ID;
  }

  setMultiShape(multi: boolean) {
    this.multiShape = multi;
  }

  protected onMapEvent(evt): void {
    if (evt.eventType == NeWMI.Map.Enums.EMapEvents.MouseDown || evt.eventType == NeWMI.Map.Enums.EMapEvents.MouseUp) {
      if (evt.button != 0) {
        // ignore any irrelevant mouse events
        return;
      }
    }
    super.onMapEvent(evt);
  }

  start(params): void {
    this.mapMngr.setCursor(this.cursor);
    // if (AppConfig.settings.map.esri)
    this.map.setNavigationMode({ pan: false }); // newmi-tbd
    super.start(params);
  }

  finish(forceFinish?: boolean): NeWMI.Geometry.Base.AGeometry {
    return super.finish(forceFinish);
  }

  static get ID() {
    return "Tool_EURON_CreateTool";
  }

}
